import './Legal.css';

function TermsAndConditions() {
  return (
    <div className="legal-page">
      <h1>Terms and Conditions</h1>
      <p className="updated">Last updated: March 2026</p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By downloading, installing, or using the KeepOrDel mobile application ("the App"), you agree to be bound by these Terms and Conditions. If you do not agree to these terms, do not use the App.
        </p>
      </section>

      <section>
        <h2>2. Description of the App</h2>
        <p>
          KeepOrDel is an offline mobile application that allows you to sort your device's photo gallery. You can swipe right to keep a photo and swipe left to delete it. The App accesses your photo library only with your permission and only for the purpose of displaying and managing your photos on your device. The App does not require an account or internet connection to function.
        </p>
      </section>

      <section>
        <h2>3. Use of the App</h2>
        <p>
          You agree to use the App only for lawful purposes and in accordance with these Terms. You are responsible for your use of the App and for any actions you take (including deleting photos). The developer is not responsible for any accidental or intentional loss of data resulting from your use of the App. We recommend backing up important photos before using delete functionality.
        </p>
      </section>

      <section>
        <h2>4. No Account or Login</h2>
        <p>
          KeepOrDel does not require you to create an account or log in. All activity occurs locally on your device. The developer does not have access to your photos or your usage of the App.
        </p>
      </section>

      <section>
        <h2>5. Intellectual Property</h2>
        <p>
          The App, including its name "KeepOrDel," design, and code, is owned by the developer. You may not copy, modify, distribute, or create derivative works of the App without permission. Your photos remain your property; the App does not claim any ownership over your content.
        </p>
      </section>

      <section>
        <h2>6. Disclaimer of Warranties</h2>
        <p>
          The App is provided "as is" and "as available" without warranties of any kind, either express or implied. The developer does not warrant that the App will be uninterrupted, error-free, or free of harmful components. You use the App at your own risk.
        </p>
      </section>

      <section>
        <h2>7. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, the developer shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of data, profits, or revenue, arising from your use or inability to use the App. The developer is not responsible for any photos deleted through the App; users are solely responsible for their choices when using the keep/delete features.
        </p>
      </section>

      <section>
        <h2>8. Changes to the App or Terms</h2>
        <p>
          The developer may update the App or these Terms from time to time. Continued use of the App after such changes constitutes acceptance of the updated Terms. Material changes may be communicated via the app store listing or within the App where applicable.
        </p>
      </section>

      <section>
        <h2>9. Termination</h2>
        <p>
          You may stop using the App at any time by uninstalling it. The developer may discontinue the App or your access to it at any time without notice. Provisions that by their nature should survive (e.g., disclaimers, limitation of liability) will remain in effect after termination.
        </p>
      </section>

      <section>
        <h2>10. Contact</h2>
        <p>
          For questions about these Terms and Conditions or the App, contact the developer: Nishan Baral at{' '}
          <a href="mailto:baralnishan987@gmail.com">baralnishan987@gmail.com</a>.
        </p>
      </section>
    </div>
  );
}

export default TermsAndConditions;
